/**
 * 自由创作(直发单镜)精简页的两句提示 —— 单一来源(Z9d 0926,接 0812 反馈)。
 *
 * ★为什么要有这个文件:自由创作这条流把文案**直接发给视频模型**,页面上没有配音、字幕、语速
 *   这几格(它们属于目的流的编排/合成环节)。此前两处提示只说了「直接发给视频模型」,没说
 *   「那几样在哪」,用户以为功能丢了(0812 反馈)。补的这一句必须两处同一份,否则一处改口一处不改,
 *   用户在页头和输入框旁读到两套说法。
 * ★反向闸(VideoSourceBar.test):两句都要带「配音、字幕、语速」与「目的流」,不许退回只说直发。
 */

/** 页头来源条(VideoSourceBar `free` 分支)的 meta。 */
export const FREE_FLOW_SOURCE_META =
  "这段文字直接发给视频模型出一段画面;要配音、字幕、语速请走目的流 —— 回视频舱选一个目的";

/** 「想拍什么」输入框旁的副标题(VideoCreatePage 自由流)。 */
export const FREE_FLOW_INTAKE_HINT =
  "这段会直接发给视频模型,写清画面就行;要配音、字幕、语速请走目的流(选一个用途)";
